
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import cookie from 'js-cookie';

const BRANCH_TEST_KEY = 'test_h5_branch';
const DEFAULT_BRANCH = 'develop';

export default function (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const branch = cookie.get(BRANCH_TEST_KEY);
  if (branch && branch !== DEFAULT_BRANCH && !to.query[BRANCH_TEST_KEY]) {
    // eslint-disable-next-line no-param-reassign
    to.query[BRANCH_TEST_KEY] = branch;
    next(to);
  }
  next();
}
